export class QuestionnaireResponse {
  public userId: string = '';
  public jobPostingId: string = '';
  public questionResponseData: QuestionResponseData[] = [];
  public referralCode: string = '';
  public questionTemplateId : string = '';
}

export class QuestionnaireDetailRequest{
  public navigation: string= '';
  public currentQuestionId: number | '' | undefined = undefined ;
  public companyCode: number = 0;
  public questionnaireInfo: QuestionnaireInfo =  new QuestionnaireInfo; 
  public hasAnsweredAll: boolean = false;
}

export class QuestionnaireInfo {
  public questionTemplateId : string = '';
  public jobPostingId: string = '';
  public questionResponseData: QuestionResponseData[] = [];
  public referralCode: string = '';
  public userId : number = 0;
  
}

// tslint:disable-next-line: max-classes-per-file
export class QuestionResponseData {
  public questionID: string = '';
  public userQuestionResponse: UserQuestionResponse = new UserQuestionResponse();
}

// tslint:disable-next-line: max-classes-per-file
export class UserQuestionResponse {
  public questionTextResponse: string = '';
  public userAnswerList: string[] = [];
  public userMultiSelectList:string[] = []
  public userSingleSelect:any = null
}
